"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _hyperlink = _interopRequireDefault(require("@ingka/hyperlink"));
var _FormFieldContext = require("./FormFieldContext");
var _helperText = _interopRequireWildcard(require("@ingka/helper-text"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FormField = props => {
  const {
    prefix = '',
    characterLimit,
    children,
    validation = {
      type: 'error'
    },
    fieldHelper = {},
    shouldValidate = false,
    valid,
    className,
    disabled,
    ...other
  } = props;
  const showValidation = shouldValidate && !valid;
  let {
    id,
    msg,
    linkText,
    link,
    type,
    ...messageProps
  } = showValidation ? validation : fieldHelper;
  if (!type && showValidation) {
    type = 'error';
  }
  const baseClass = `${prefix}form-field`;
  const classes = (0, _classnames.default)(`${baseClass}`, type && `${baseClass}--${type}`, characterLimit && `${baseClass}--with-character-limit`, disabled && `${prefix}disabled`, className);
  const describedById = id;
  const [characterCount, setCharacterCount] = (0, _react.useState)(0);
  const validCharacterLimit = characterLimit !== 0 && characterLimit > 0;
  return _react.default.createElement(_FormFieldContext.FormFieldProvider, {
    valid: valid,
    shouldValidate: shouldValidate,
    setCharacterCount: setCharacterCount
  }, _react.default.createElement("div", _extends({
    className: classes
  }, other), _react.default.Children.map(children, child => {
    if (child.props.list) return child;
    const extraProps = {
      describedById: msg ? describedById : null
    };
    return _react.default.cloneElement(child, extraProps);
  }), !disabled && (msg || validCharacterLimit) && _react.default.createElement("div", {
    className: `${baseClass}__content`
  }, _react.default.createElement(_helperText.default, _extends({
    prefix: prefix,
    id: id,
    shouldValidate: shouldValidate,
    valid: valid
  }, messageProps), msg, linkText && link && _react.default.createElement(_hyperlink.default, {
    prefix: prefix,
    url: link,
    text: linkText
  })), validCharacterLimit && _react.default.createElement(_helperText.CharacterCount, {
    prefix: prefix,
    characterCount: characterCount,
    limit: characterLimit
  }))));
};
var _default = FormField;
exports.default = _default;